export default __webpack_public_path__ + "static/media/Co-Branded-KWFL-Cover.985a2a57.png";